import {
  IItem,
  INumericRangeValidatable,
} from "../items";
import { AbstractDocumentItemAlert } from "./AbstractDocumentItemAlert";

export class NumericRangeAlert extends AbstractDocumentItemAlert<IItem & INumericRangeValidatable> {
  constructor(itemSetId: number, item: IItem & INumericRangeValidatable) {
    super(itemSetId, item, true);
  }

  get kind(): string {
    return "数値";
  }

  get target(): string {
    return this._detectedItem.name
      ? ("「" + this._detectedItem.name + "」")
      : ("id:" + this._detectedItem.id);
  }

  get description(): string {
    const hasLowerLimit = (this._detectedItem.lowerLimit !== null && this._detectedItem.lowerLimit !== undefined);
    const hasUpperLimit = (this._detectedItem.upperLimit !== null && this._detectedItem.upperLimit !== undefined);
    if (hasLowerLimit && hasUpperLimit) {
      return "値が" + this._detectedItem.lowerLimit + "から" + this._detectedItem.upperLimit + "の範囲内ではありません。";
    }
    if (hasLowerLimit) {
      return "値が" + this._detectedItem.lowerLimit + "を下回っています。";
    }
    if (hasUpperLimit) {
      return "値が" + this._detectedItem.upperLimit + "を上回っています。";
    }
    return null;
  }
}
